/* Signature search prompts: the typewriter for the always-open header search bar.
   Ported verbatim from Unfazed 3.0 (signature-custom.js); on Impact 5.1.1 it lives in its own file. */
(function () {
  'use strict';

  /* =======================================================================
     Header search bar: rotating prompts
     -----------------------------------------------------------------------
     Ported from the live Safezone theme's <search-form>, which types the next
     prompt in character by character and deletes the previous one, on a loop.
     Same timings, so the two stores feel identical.

     One structural difference: on Safezone the field is a real <input> and the
     script animates its `placeholder` attribute. Stretch's always-open bar is a
     LINK that opens the search drawer, with the text in a <span>, so this walks
     `textContent` instead. The prompts arrive as data attributes on that span,
     the first one being whatever Liquid already rendered, so the bar is never
     empty before the script runs.
     ======================================================================= */
  (function () {
    var TYPING = 100;
    var DELETING = 60;
    var AFTER_DELETE = 500;
    var BEFORE_FIRST_DELETE = 2000;
    var AFTER_WORD = 2400;

    // A permanent text animation is exactly what this asks to switch off.
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      return;
    }

    function start(el) {
      if (el.dataset.promptsRunning) {
        return;
      }

      var prompts = [el.textContent.trim(), el.dataset.placeholderTwo, el.dataset.placeholderThree]
        .filter(function (value) { return value; });

      if (prompts.length < 2) {
        return;
      }

      el.dataset.promptsRunning = 'true';

      var index = 0;

      function typeIn(next, done) {
        // Keep any prefix the two prompts share (3 chars or more), the way the
        // Safezone original does, so "Cauta Nike" -> "Cauta Air Jordan" retypes
        // only the tail instead of the whole line.
        var rest = el.textContent.length >= 3 && next.indexOf(el.textContent) === 0
          ? next.slice(el.textContent.length)
          : next;

        var timer = setInterval(function () {
          el.textContent += rest.charAt(0);

          if (rest.length === 1) {
            clearInterval(timer);
            done();
            return;
          }

          rest = rest.slice(1);
        }, TYPING);
      }

      function deleteOut(next, done) {
        var timer = setInterval(function () {
          el.textContent = el.textContent.slice(0, -1);

          if (el.textContent.length === 0
            || (el.textContent.length >= 3 && next.indexOf(el.textContent) === 0)) {
            clearInterval(timer);
            done();
          }
        }, DELETING);
      }

      function next() {
        index = (index + 1) % prompts.length;

        var upcoming = prompts[index];

        deleteOut(upcoming, function () {
          setTimeout(function () {
            typeIn(upcoming, function () {
              setTimeout(next, AFTER_WORD);
            });
          }, AFTER_DELETE);
        });
      }

      setTimeout(next, BEFORE_FIRST_DELETE);
    }

    function sync(root) {
      (root || document).querySelectorAll('.header__search-bar-text').forEach(function (el) {
        // Both always-open bars carry this class, the desktop one in the icon row
        // and the mobile one in its own search row, and the layout hides whichever
        // does not apply. Animating a hidden bar would just burn timers, so only
        // the one actually on screen starts; a resize runs this again.
        if (el.getClientRects().length) {
          start(el);
        }
      });
    }

    window.addEventListener('resize', function () { sync(); });
    document.addEventListener('shopify:section:load', function (event) { sync(event.target); });

    if (document.readyState !== 'loading') {
      sync();
    } else {
      document.addEventListener('DOMContentLoaded', function () { sync(); });
    }
  })();
})();
